
<div id="preloader" *ngIf="preloader" ></div>




<div  *ngIf="loginDisplay">
<app-header *ngIf="headerFooter"></app-header>



<router-outlet></router-outlet>



<app-footer *ngIf="headerFooter"></app-footer>
</div>



